import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "header-menu-item-wrapper top-link header-desktop-element" }
const _hoisted_2 = { class: "name txt-header-nav" }
const _hoisted_3 = { class: "submenu-nav-wrapper" }
const _hoisted_4 = { class: "submenu-nav" }
const _hoisted_5 = ["value", "onClick"]
const _hoisted_6 = { class: "name txt-header-nav" }
const _hoisted_7 = { class: "submenu-nav-wrapper-mobile" }
const _hoisted_8 = { class: "submenu-nav-mobile" }
const _hoisted_9 = ["value", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_chevron_down = _resolveComponent("icon-chevron-down")!
  const _directive_on_click_outside = _resolveDirective("on-click-outside")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.language.label), 1),
      _createVNode(_component_icon_chevron_down, { class: "menu-link icon" }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languages, (item) => {
            return (_openBlock(), _createElementBlock("span", {
              class: "txt-header-subnav menu-link",
              value: item.code,
              onClick: ($event: any) => (_ctx.changeLanguage(item))
            }, _toDisplayString(item.name), 9, _hoisted_5))
          }), 256))
        ])
      ])
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", {
      class: "header-menu-item-wrapper top-link top-menu header-mobile-element",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSubMenu && _ctx.toggleSubMenu(...args)))
    }, [
      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.language.label), 1),
      _createVNode(_component_icon_chevron_down, { class: "menu-link icon" }),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languages, (item) => {
            return (_openBlock(), _createElementBlock("span", {
              class: "txt-header-subnav menu-link",
              value: item.code,
              onClick: ($event: any) => (_ctx.changeLanguage(item))
            }, _toDisplayString(item.name), 9, _hoisted_9))
          }), 256))
        ])
      ])
    ])), [
      [_directive_on_click_outside, _ctx.outside]
    ])
  ], 64))
}